<template>
  <div class="container">
    <div class="d-flex align-items-center justify-content-between mb-5">
      <PageTitle>Forecast</PageTitle>
      <button v-if="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner || userIsContextCompanyManager" @click="newForecastModal()" class="btn btn-primary">Nuovo</button>
    </div>

    <div v-if="forecasts && forecasts.length === 0">
      Nessun forecast presente.
    </div>
    <template v-else-if="forecasts">
      <div class="row py-2" v-for="(forecast, index) of forecasts" :key="index">
        <div class="col">
          <p>{{forecast.name}} <small>creato a partire da <strong>{{forecast.model == null ? 'Master' : forecast.model }}</strong></small></p>
        </div>
        <div class="col-auto">
          <router-link v-if="!currentForecast || currentForecast.id !== forecast.id" class="btn btn-outline-primary" :to="{ name: 'operative-company', query: { forecast: forecast.id } }">
            Seleziona
          </router-link>
          <router-link v-else class="btn btn-outline-danger col-auto" :to="{ name: 'operative-company' }">
            Deseleziona
          </router-link>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary" @click="editForecastModal(forecast)">
            Modifica
          </button>
        </div>
        <div class="col-auto">
          <AwlConfirm
            status="danger"
            @confirm="deleteForecast(forecast.id)"
            title="Cancella"
          >
            Sei sicuro di voler cancellare {{forecast.name}}?
          </AwlConfirm>
        </div>
      </div>
    </template>
    <BModal v-if="forecast" :title="forecast.id ? 'Modifica' : 'Nuovo'" dialog-class="modal--type-dialog" id="forecast-modal" ref="forecast-modal" hide-footer centered scrollable>
      <p class="mb-0" v-if="forecast.id">Modifica il forecast esistente</p>
      <p class="mb-0" v-else>Crea un nuovo forecast</p>
      <FormContainer @submitForm="submit">
        <FormInputSelectWidget
          class="mt-3"
          label="Scegli un modello"
          v-model="forecast.model"
          :options="forecastModels"
          optionValue="value"
          />

        <FormInputTextWidget
          class="mb-5 mt-2"
          label="Nome"
          placeholder="Macchina agricola"
          v-model="forecast.name"
          :errorMsg="errorHash.forecastName"
          type="text"
          @input="removeError('forecastName')"
        />
        <div class="text-right">
          <button class="btn btn-primary px-3">Salva</button>
        </div>
      </FormContainer>
    </BModal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue';
import validateMixin from '../../../../libs/Form/mixins/validate';
import operativePageMixin from '../../../../mixins/operativePage';

export default {
  mixins: [operativePageMixin, validateMixin],
  components: {
    BModal,
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    FormContainer: () => import('../../../../libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('../../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    AwlConfirm: () => import('../../../../libs/Modals/components/AwlConfirm'),
  },
  data () {
    return {
      forecasts: null,
      forecast: { },
      forecastModels: [{ value: null, label: 'Master' }],
    };
  },
  computed: {
    currentForecast () {
      return this.$appState.forecast || null;
    },
    forecastModal () {
      return this.$refs['forecast-modal'];
    },
  },
  methods: {
    submit () {
      if (!this.isValid()) {
        return;
      }

      if (!this.forecast.id) {
        return this.createForecast();
      }

      return this.editForecast();
    },
    isValid () {
      if (!this.forecast.name) {
        this.addError('Inserire un nome', 'forecastName');
      }

      return !this.hasErrors;
    },
    createForecast () {
      this.$api.createForecast(this.company.id, this.forecast).then(async res => {
        this.forecastModal.hide();
        await this.getForecasts();
        this.setForecast(res.data);
        await this.$router.push({ name: 'operative-company', query: { forecast: res.data.id } });
      }).catch(this.$log.error);
    },
    editForecast () {
      this.$api.updateForecast(this.company.id, this.forecast.id, this.forecast).then(res => {
        this.forecastModal.hide();
        this.getForecasts();

        if (this.$appState.forecast?.id === this.forecast.id) {
          this.setForecast(res.data);
        }
      }).catch(this.$log.error);
    },
    deleteForecast (forecastId) {
      const currentForecast = forecastId === this.$appState.forecast?.id;
      if (currentForecast) {
        this.$appState.forecast = null;
      }

      this.$api.deleteForecast(this.company.id, forecastId).then(() => {
        this.forecastModal.hide();
        this.getForecasts();

        if (currentForecast) {
          this.$router.replace({ name: 'operative-company.forecast' });
        }
      }).catch(this.$log.error);
    },
    newForecastModal () {
      this.forecast = { model: null };
      this.forecastModal.show();
    },
    editForecastModal (forecast) {
      this.forecast = forecast;
      this.forecastModal.show();
    },
    getForecasts () {
      return new Promise((resolve, reject) => {
        this.$api.getForecasts(this.company.id).then(res => {
          this.forecasts = res.data.forecasts;

          this.forecastModels = [{ value: null, label: 'Master' }];
          this.forecasts.forEach(el => this.forecastModels.push({ value: el.id, label: el.name }));
          resolve(this.forecasts);
        }).catch(reject);
      });
    },
    setForecast (forecast) {
      this.$appState.forecast = forecast;
    },
    removeForecast () {
      if (!this.$appState.forecast) {
        return;
      }

      this.$appState.forecast = null;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function (company) {
        if (!company || !company.id) {
          return;
        }

        this.getForecasts();
      },
    },
  },
};

</script>
